module.exports = __webpack_public_path__ + "static/media/reactLogo.4ade5cac.png";